// Lógica pura das perguntas de questionário (condicionais e validação).
import type { Pergunta } from '@/lib/types'

/** Uma pergunta condicional só aparece se a pergunta referida tiver o valor esperado. */
export function perguntaVisivel(p: Pergunta, respostas: Record<string, unknown>): boolean {
  if (!p.condicao) return true
  const v = respostas[p.condicao.pergunta_id]
  return String(v ?? '').toLowerCase() === p.condicao.valor.toLowerCase()
}

/** Perguntas obrigatórias visíveis que ainda não foram respondidas. */
export function obrigatoriasFaltando(perguntas: Pergunta[], respostas: Record<string, unknown>): Pergunta[] {
  return perguntas.filter(p =>
    perguntaVisivel(p, respostas) &&
    p.obrigatoria &&
    (respostas[p.id] === undefined || respostas[p.id] === '' || respostas[p.id] === null)
  )
}
